import React, { useCallback, useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import TipTapViewer from "../../components/TipTapViewer";
import { TermosUsoService } from "../../service/termos_uso_service";

function TermosUso({ cardSx, titleSx }) {
	const [loading, setLoading] = useState(true);
	const [erro, setErro] = useState("");
	const [termo, setTermo] = useState(null);

	const carregar = useCallback(async () => {
		setLoading(true);
		try {
			setTermo(await new TermosUsoService().getLatest());
			setErro("");
		} catch (error) {
			setErro(error.message || "Erro ao carregar os Termos de Uso.");
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		carregar();
	}, [carregar]);

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
				<CircularProgress sx={{ color: "#1a9e8f" }} />
			</Box>
		);
	}

	if (erro) {
		return (
			<Alert
				severity="error"
				action={
					<Button color="inherit" size="small" onClick={carregar}>
						Tentar novamente
					</Button>
				}
			>
				{erro}
			</Alert>
		);
	}

	return (
		<Box sx={cardSx}>
			<Typography variant="subtitle1" sx={{ ...titleSx, mb: 0.5 }}>
				Termos de Uso
			</Typography>
			{termo?.createdAt && (
				<Typography sx={{ color: "#777", fontSize: "13px", mb: 3 }}>
					Versão publicada em {new Date(termo.createdAt).toLocaleDateString("pt-BR")}
				</Typography>
			)}

			{termo?.conteudo ? (
				<Box sx={{ maxHeight: "65vh", overflowY: "auto", color: "#444", fontSize: "15px" }}>
					<TipTapViewer content={termo.conteudo} />
				</Box>
			) : (
				<Typography sx={{ color: "#777", fontSize: "14px" }}>
					Nenhum termo de uso foi cadastrado ainda.
				</Typography>
			)}
		</Box>
	);
}

export default TermosUso;
